module.exports = __webpack_public_path__ + "media/packs/images/flags/UY-7cc6ae6f934b98db72ce69b302f07ef2.png";